// extracted by mini-css-extract-plugin
export default {"container":"postContent_container__BOHV8","horizontal":"postContent_horizontal__K+V+d","vertical":"postContent_vertical__Jj4N1"};